module.exports = __webpack_public_path__ + "static/avatar_5-205ee82152f2aae9be192633ef66038e.png";